import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { radius, space } from '@elementary/common-ui/style/utils';
import { PipelineIncidentData } from './types';
import PipelineRunInfo from './PipelineRunInfo';

const Wrapper = styled(FlexColumn)`
  background-color: ${({ theme }) => theme.palette.surface.soft};
  padding: ${space('lg', 'xxl')};
  gap: ${space('xxl')};
  border-radius: ${radius('lg')};
`;

type Props = {
  data: PipelineIncidentData;
};

const PipelineExecutionInfo = ({ data }: Props) => (
  <Wrapper>
    <PipelineRunInfo eventId={data.rootEventId} connectorData={data} />
  </Wrapper>
);

export default PipelineExecutionInfo;
